import $ from "jquery";

$(document).ready(function() {
	$('.jsInfoCardButton').on('click', function () {
		$(this).toggleClass('is-active');
		$(this).closest('.info-card').find('.jsInfoCardHidden').slideToggle(250);
		$(this).closest('.info-card').toggleClass('is-active')
	});
})